import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FileUploadModule } from 'primeng/fileupload';
import { FileListComponent } from '../file-list/file-list.component';
import { Observable, of, Subject, takeUntil } from 'rxjs';
import { FileRepresentation } from '@/components/form-builder/form-builder.types';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'sm-file-uploader',
  imports: [FileUploadModule, FileListComponent, CommonModule, TranslateModule],
  templateUrl: './file-uploader.component.html',
  styleUrl: './file-uploader.component.scss',
})
export class FileUploaderComponent implements OnInit, OnDestroy {
  //services
  messageService = inject(MessageService);
  // p-fileuploader
  @Input() existingFiles = false;
  @Input() mode: 'basic' | 'advanced' = 'advanced';
  @Input() accept = '*/*';
  @Input() showUploadButton = true;
  @Input() maxFileSize = 31457280;
  @Input() multiple = true;
  @Input() disabled = false;
  @Input() existingLabel = 'common.files.existingFiles';
  @Input() existingFileHeader = true;
  @Input() onFileSelect: ($event: any) => void = () => {
    console.warn('onFileSelect not passed');
  };
  @Input() onFileRemoved: ($event: any) => void = () => {
    console.warn('onFileRemoved not passed');
  };
  @Input() chooseLabel = 'common.select';
  @Input() cancelLabel = 'common.cancel';

  //p-filelist
  @Input() files: Observable<FileRepresentation[]> = of([]);
  @Input() onFileRepresentationChange: ($event: any) => void = () => {
    console.warn('OnFileRepresentationChange not passed');
  };
  @Input() openFile: ($event: FileRepresentation) => void = () => {
    console.warn('openFile not passed');
  };
  @Input() onFileDownLoad: ($event: any) => void = () => {
    console.warn('onFileDownLoad not passed');
  };

  @Input() onAllRemoved: () => void = () => {
    console.warn('onAllRemoved not passed');
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  @Input() setResetMethod: (resetFn: () => void) => void = () => {};

  @Input() value: Observable<File[]> = of([]);

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    if (!this.maxFileSize) {
      this.maxFileSize = 31457280;
    }

    this.setResetMethod?.(() => this.resetSelectedFiles());

    this.value.pipe(takeUntil(this.destroy$)).subscribe(files => {
      this.selectedFiles = files || [];
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectedFiles: File[] = [];

  onSelectInternal(event: { currentFiles: File[] }) {
    const totalSize = event.currentFiles.reduce((sum, file) => sum + file.size, 0);
    if (totalSize > this.maxFileSize) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Taille Maximale',
        detail: 'Les fichiers sélectionnés dépassent la taille maximale autorisée',
      });
      return false;
    }
    this.selectedFiles = [...event.currentFiles];
    this.onFileSelect(event);
    return true;
  }

  onRemoveInternal($event: any) {
    // this.selectedFiles = this.selectedFiles.filter(f => f.name !== event?.file?.name);
    this.onFileRemoved(event);
  }

  resetSelectedFiles() {
    this.selectedFiles = [];
    this.onAllRemoved?.();
  }
}
